// future server setup we need this
const autoSwitch = () => {
  //TBC  this change only for Marcus to have a demo
  if (window.location.hostname == "localhost") {
    return "http://localhost:4000/api/";
  } else if (window.location.hostname == "10.96.20.74") {
    return "http://10.96.20.74:4000/api";
  } else {
    return "https://iteach2.dev.pearson.com.hk/api/";
  }
};

export const config = {
  grqphQl_url: autoSwitch(),
  forgerock_url:
    "https://iam-stage.pearson.com/auth/json/realms/pearson/authenticate",
  //dev http://iteach2.dev.pearson.com.hk/api/s
  //local http://localhost:3010/api/
  //Staging https://iteach2.stg.pearson.com.hk/api/
  mode: "Pro",
  recaptcharKey: "6LeXhZ0UAAAAAMeIcz45c3jORAm8iNL-feLvvuVD",
  googleAnalytics: "UA-52750440-22"
};
